function EmailNotification({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '56'} height=${(dimensions * 48) / 56 || '48'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 48" fill="none">
      <path d="M48 0H5.33333C2.4 0 0.0266666 2.4 0.0266666 5.33333L0 37.3333C0 40.2667 2.4 42.6667 5.33333 42.6667H26.6667V37.3333H5.33333V10.6667L26.6667 24L48 10.6667V24H53.3333V5.33333C53.3333 2.4 50.9333 0 48 0ZM26.6667 18.6667L5.33333 5.33333H48L26.6667 18.6667ZM40.9067 48L31.4667 38.56L35.2267 34.8L40.88 40.4533L52.1867 29.1467L56 32.9067L40.9067 48Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default EmailNotification;
